module.exports = __webpack_public_path__ + "img/logo_main_left_menu.799bb510.svg";